<template>
  <div>
    <input :class="{ 'green-border': number1 !== null && number1 !== '' }" type="number" min="1" max="999" placeholder="0" v-model="number1" @input="emitChange"/>
    <input :class="{ 'green-border': number2 !== null && number2 !== '' }" type="number" min="1" max="999" placeholder="0" v-model="number2" @input="emitChange"/>
    <input :class="{ 'green-border': number3 !== null && number3 !== '' }" type="number" min="1" max="999" placeholder="0" v-model="number3" @input="emitChange"/>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const number1 = ref(null);
const number2 = ref(null);
const number3 = ref(null);

const emitChange = () => {
  const values = {
    number1: number1.value,
    number2: number2.value,
    number3: number3.value
  };
  this.$emit('change', values);
}

</script>

<style scoped>
div {
  display: inline-flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 130px;
  justify-content: center;
  margin-bottom: 20px;

  & input {
    background-color: whitesmoke;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: var(--ion-color-primary) dashed 3px;

    text-align: center;
    max-lines: 1;
    font-size: 1.5rem;

    &:focus {
      outline: none;
      border: var(--ion-color-primary) solid 3px;
    }
  }

  .green-border {
    border: #00be00 solid 3px;
  }
}
</style>
